export const paginationConstants = {
  userSearchDrawer: {
    DEFAULT_PAGE: 1,
    DEFAULT_PAGE_SIZE: 10
  }
}
